import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Button, Form, Input, InputNumber, Modal, Select, message } from "antd";
import _, { get } from "lodash";
import React, { forwardRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppBaseSelect from "../../../../../../core/components/baseSelect";
import service from "../../../../../../services";
import barrierService from "../../../../../../services/BarrierService";
import { PAGINATION } from "../../../_redux/constant";
import { barrierThunks } from "../../../_redux/thunk";

function AddEditCamera({ modal, onShowModal }) {
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  let {
    visible,
    stations,
    isEdit,
    id,
    data,
    gates: currentGates,
    dvrs: currentDvrs,
  } = modal;

  const dispatch = useDispatch();
  const [param, setParam] = useState({
    page: PAGINATION.camera.page,
    size: PAGINATION.camera.size,
  });

  const [buttonLoading, setButtonLoading] = useState({
    value: false,
  });

  const [gates, setGates] = useState({
    value: [],
  });

  const [dvrs, setDvrs] = useState({
    value: [],
  });

  useEffect(() => {
    setGates(currentGates);
    setDvrs(currentDvrs);
  }, [currentGates, currentDvrs]);

  const direction = useSelector(
    (state) => state.barrier.barrierLog.filterData.direction
  );

  const cameraType = useSelector(
    (state) => state.barrier.barrierLog.filterData.camera_type
  );

  const { Option } = Select;
  const [form] = Form.useForm();

  let title = "Tạo mới thông tin camera barrier";
  if (isEdit) {
    title = "Chỉnh sửa thông tin camera barrier";
  }

  const directions = [];
  for (let i in direction) {
    directions.push(<Option key={i}>{direction[i]}</Option>);
  }

  const cameraTypes = [];
  for (let i in cameraType) {
    cameraTypes.push(<Option key={i}>{cameraType[i]}</Option>);
  }

  const _callApi = async (id, data, isStationChanged, isEdit) => {
    setButtonLoading((prev) => ({
      ...prev,
      value: true,
    }));

    let response = null;
    if (isEdit) {
      response = await barrierService.updateCamera(id, data);
    } else {
      response = await barrierService.createCamera(data);
    }
    setButtonLoading((prev) => ({
      ...prev,
      value: false,
    }));
    if (response && response.data && response.data.success) {
      await dispatch(barrierThunks.getCameraThunk(param));
      if (isStationChanged)
        await dispatch(barrierThunks.getLogFilterDataThunk());
      message.success(`${title} thành công.`);
      onShowModal();
    } else {
      message.error(get(response, "data.message", "Có lỗi xảy ra."), 5);
    }
  };

  const _handleSubmit = async () => {
    try {
      let validate = await form.validateFields();
      if (!validate.outOfDate) {
        const {
          station_id,
          name,
          gate_id,
          dvr_id,
          direction,
          ip,
          port,
          username,
          password,
          gbarrier_ip,
          gbarrier_port,
          type,
          roi,
          channel,
          sn,
          pc_mac,
        } = form.getFieldsValue([
          "station_id",
          "name",
          "gate_id",
          "direction",
          "ip",
          "port",
          "username",
          "password",
          "gbarrier_ip",
          "gbarrier_port",
          "type",
          "roi",
          "channel",
          "dvr_id",
          "sn",
          "pc_mac",
        ]);
        const data = {
          station_id,
          station_name: _.get(
            _.find(stations, (station) => station.station_id === station_id),
            "station_name",
            ""
          ),
          gate_id,
          gate_name: _.get(
            _.find(gates, (gate) => gate.gate_id === gate_id),
            "gate_name",
            ""
          ),
          dvr_id,
          direction,
          ip,
          port,
          name,
          username,
          password,
          gbarrier_ip,
          gbarrier_port,
          type,
          roi: roi.split(",").map((item) => parseInt(item)),
          channel,
          sn: sn?.trim() || undefined,
          pc_mac: pc_mac?.trim() || undefined,
        };

        let isStationChanged = false;
        if (isEdit) {
          if (data?.station_id?.toString() != station_id)
            isStationChanged = true;
        } else {
          isStationChanged = true;
        }
        _callApi(id, data, isStationChanged, isEdit);
        _handleReset();
      }
    } catch (error) {}
  };

  const _handleReset = () => {
    form.resetFields();
    setGates(currentGates);
    setDvrs(currentDvrs);
  };

  const _handleCancel = () => {
    form.resetFields();
    onShowModal();
  };

  const _handleSelectStation = async () => {
    const stationId = form.getFieldValue("station_id");
    const response = await barrierService.getGateByStationId({
      station_id: stationId,
    });
    form.setFieldsValue({ gate_id: null });
    if (response && response.data && response.data.success) {
      setGates(get(response.data, "data"));
    } else {
      setGates([]);
    }

    const dvrResponse = await service.IOT.getListDvrInfo({
      station_search: { station_id: [stationId] },
      limit: 1000,
      offset: 1,
    });

    const dvrs = [];
    if (dvrResponse.success && _.size(dvrResponse.data) > 0) {
      _.forEach(dvrResponse.data, (dvr) => {
        dvrs.push({
          dvr_id: dvr._id,
          dvr_name: _.get(dvr, "dvr_name", ""),
        });
      });
    }
    setDvrs(dvrs);
  };

  const defaultRoi = {
    0: 0,
    1: 0,
    2: 1920,
    3: 1080,
  };

  function CompactedInput({ value, onChange }, ref) {
    let [xCoordinate, yCoordinate, width, height] = value.split(",");
    xCoordinate = xCoordinate || defaultRoi[0];
    yCoordinate = yCoordinate || defaultRoi[1];
    width = width || defaultRoi[2];
    height = height || defaultRoi[3];
    function triggerChange(changedValue, index) {
      if (onChange) {
        const values = value.split(",");
        values[index] = changedValue || defaultRoi[index];
        onChange(values.join(","));
      }
    }

    return (
      <span ref={ref}>
        <Input.Group>
          <InputNumber
            placeholder="x"
            onChangeCapture={({ target: { value: xCoordinate } }) => {
              triggerChange(xCoordinate, 0);
            }}
            value={xCoordinate}
            className="w-25"
          />
          <InputNumber
            placeholder="y"
            onChangeCapture={({ target: { value: yCoordinate } }) => {
              triggerChange(yCoordinate, 1);
            }}
            value={yCoordinate}
            className="w-25"
          />
          <InputNumber
            placeholder="w"
            onChangeCapture={({ target: { value: width } }) => {
              triggerChange(width, 2);
            }}
            value={width}
            className="w-25"
          />
          <InputNumber
            placeholder="h"
            onChangeCapture={({ target: { value: height } }) => {
              triggerChange(height, 3);
            }}
            value={height}
            className="w-25"
          />
        </Input.Group>
      </span>
    );
  }

  const RoiInput = forwardRef(CompactedInput);

  return (
    <Modal
      destroyOnClose={true}
      width={600}
      onCancel={() => {
        _handleCancel();
      }}
      title={title}
      open={visible}
      maskClosable={true}
      footer={[
        <Button key="back" onClick={_handleReset} type="dashed">
          Làm mới
        </Button>,
        <Button key="cancel" onClick={_handleCancel}>
          Đóng
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={_handleSubmit}
          loading={buttonLoading.value}
        >
          Lưu
        </Button>,
      ]}
    >
      <Form
        {...layout}
        autoComplete="off"
        layout="horizontal"
        form={form}
        onFinish={_handleSubmit}
        initialValues={{
          ["station_id"]: data?.station_id,
          ["name"]: data?.name,
          ["gate_id"]: data?.gate_id,
          ["direction"]: data?.direction,
          ["ip"]: data?.ip,
          ["port"]: data?.port,
          ["channel"]: data?.channel,
          ["type"]: data?.type,
          ["dvr_id"]: data?.dvr_id,
          ["username"]: data?.username,
          ["password"]: data?.password,
          ["gbarrier_ip"]: data?.gbarrier_ip,
          ["gbarrier_port"]: data?.gbarrier_port,
          ["roi"]: data?.roi?.toString(),
          ["sn"]: data?.sn,
          ["pc_mac"]: data?.pc_mac,
        }}
        labelAlign={"left"}
      >
        <Form.Item
          label={"Kho"}
          rules={[
            {
              required: true,
              message: "Vui lòng chọn kho",
            },
          ]}
          name={"station_id"}
        >
          <AppBaseSelect
            allowClear
            allowConvert={true}
            dataSource={stations}
            valueKey="station_id"
            labelKey="station_name"
            placeholder="Chọn kho"
            style={{ width: "100%" }}
            onSelect={_handleSelectStation}
          />
        </Form.Item>

        <Form.Item
          label={"Cổng"}
          rules={[
            {
              required: true,
              message: "Vui lòng chọn cổng",
            },
          ]}
          name={"gate_id"}
        >
          <AppBaseSelect
            allowClear
            allowConvert={true}
            dataSource={gates}
            valueKey="gate_id"
            labelKey="gate_name"
            placeholder="Chọn cổng"
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          label={"DVR"}
          rules={[
            {
              required: true,
              message: "Vui lòng chọn DVR",
            },
          ]}
          name={"dvr_id"}
        >
          <AppBaseSelect
            allowClear
            allowConvert={true}
            dataSource={dvrs}
            valueKey="dvr_id"
            labelKey="dvr_name"
            placeholder="Chọn DVR"
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          label={"Hướng cổng"}
          rules={[
            {
              required: true,
              message: "Vui lòng chọn hướng cổng",
            },
          ]}
          name={"direction"}
        >
          <Select
            allowClear
            style={{ width: "100%" }}
            placeholder="Chọn hướng cổng"
          >
            {directions}
          </Select>
        </Form.Item>

        <Form.Item
          label={"Tên camera"}
          rules={[
            {
              required: true,
              message: "Vui lòng nhập tên camera",
            },
          ]}
          name={"name"}
        >
          <Input placeholder="Nhập tên camera" />
        </Form.Item>

        <Form.Item
          label={"Loại camera"}
          rules={[
            {
              required: true,
              message: "Vui lòng chọn loại camera",
            },
          ]}
          name={"type"}
        >
          <Select
            allowClear
            style={{ width: "100%" }}
            placeholder="Chọn loại camera"
          >
            {cameraTypes}
          </Select>
        </Form.Item>

        <Form.Item
          label={"IP camera"}
          rules={[
            {
              required: true,
              message: "Vui lòng nhập camera IP",
            },
          ]}
          name={"ip"}
        >
          <Input placeholder="Nhập tên camera" />
        </Form.Item>

        <Form.Item label={"SN camera"} name={"sn"}>
          <Input placeholder="Nhập mã SN camera" />
        </Form.Item>

        <Form.Item
          label={"Port camera"}
          rules={[
            {
              required: true,
              message: "Vui lòng nhập port cho camera",
            },
          ]}
          name={"port"}
        >
          <Input placeholder="Nhập port camera" />
        </Form.Item>

        <Form.Item
          label={"Kênh"}
          rules={[
            {
              required: true,
              message: "Vui lòng nhập kênh cho camera",
            },
          ]}
          name={"channel"}
        >
          <InputNumber min={0} className="w-100" rows={3} placeholder="Kênh" />
        </Form.Item>

        <Form.Item
          label={"IP server"}
          rules={[
            {
              required: true,
              message: "Vui lòng nhập IP server",
            },
          ]}
          name={"gbarrier_ip"}
        >
          <Input placeholder="Nhập ip server" />
        </Form.Item>

        <Form.Item
          label={"Port server"}
          rules={[
            {
              required: true,
              message: "Vui lòng nhập port server",
            },
          ]}
          name={"gbarrier_port"}
        >
          <Input placeholder="Nhập port server" />
        </Form.Item>

        <Form.Item label={"MAC server"} name={"pc_mac"}>
          <Input placeholder="Nhập MAC server" />
        </Form.Item>

        <Form.Item
          label={"Tên đăng nhập camera"}
          rules={[
            {
              required: true,
              message: "Vui lòng nhập tên đăng nhập camera",
            },
          ]}
          name={"username"}
        >
          <Input placeholder="Nhập tên đăng nhập" />
        </Form.Item>

        <Form.Item
          label={"Mật khẩu camera"}
          name={"password"}
          rules={[
            {
              required: true,
              message: "Vui lòng nhập mật khẩu camera",
            },
          ]}
          autoComplete={"off"}
        >
          <Input.Password
            autoComplete={"off"}
            placeholder="Nhập mật khẩu camera"
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>

        <Form.Item label={"ROI"} name={"roi"} initialValue={"0,0,1920,1080"}>
          <RoiInput />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddEditCamera;
